import styled from 'styled-components';

export const ListUnstyled = styled.ul`
  padding: 0;
`;

export const ListItemUnstyled = styled.li`
  list-style: none;
`;
